// checks if information banner should display in products page upon customer visit
// if (shouldDisplayBanner()) {
//   document.querySelector(".information-banner").classList.add("visible");
// } else {
//   document.querySelector(".information-banner").classList.remove("visible");
// };

function shouldDisplayBanner() {
  return localStorage.getItem('time-visit') === null || 
    islastVisitOver24Hours(localStorage.getItem('time-visit'));
}

function islastVisitOver24Hours(lastVisitedTime) {
  return (new Date().getTime() - lastVisitedTime) > 1000 * 60 * 60 * 24;
}

function handleBannerCancel(e){
  localStorage.setItem('time-visit', `${new Date().getTime()}`);

  document.querySelector(".information-banner").classList.remove("visible");
}

document.querySelector(".information-banner-cross").addEventListener('click', handleBannerCancel);